(() => {
  const measurementId = 'G-TQ9P3818G9';
  const allowedEvents = new Set([
    'product_where_to_pull_click',
    'product_recommendation_click',
    'product_collection_click',
  ]);
  const queue = [];
  let analyticsAllowed = false;
  let googleQueueReady = false;

  const cleanText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

  const internalDestinationPath = (value) => {
    if (!value) return '';
    try {
      const destination = new URL(value, window.location.href);
      return destination.origin === window.location.origin ? destination.pathname : '';
    } catch (_) {
      return '';
    }
  };

  const sourceContext = () => {
    const context = document.querySelector('[data-tcgking-product-context]');
    const pathParts = window.location.pathname.split('/').filter(Boolean);
    return {
      source_product_id: context?.dataset.productId || '',
      source_product_handle: context?.dataset.productHandle || (pathParts[0] === 'products' ? pathParts[1] || '' : ''),
      source_product_title: context?.dataset.productTitle || cleanText(document.querySelector('main h1')?.textContent),
      source_product_type: context?.dataset.productType || '',
      product_tcg: context?.dataset.productTcg || '',
      product_expansion: context?.dataset.productExpansion || '',
      source_product_path: window.location.pathname,
    };
  };

  const destinationProduct = (link) => ({
    destination_product_id: link.dataset.destinationProductId || '',
    destination_product_handle: link.dataset.destinationProductHandle || link.pathname.split('/products/')[1]?.split(/[?#]/)[0] || '',
    destination_product_title: cleanText(link.dataset.destinationProductTitle || link.querySelector('img')?.alt || link.textContent),
    destination_url: link.href,
  });

  const normalisePayload = (eventData) => {
    const payload = { ...sourceContext(), ...eventData };
    const destinationPath = internalDestinationPath(payload.destination_url);
    if (destinationPath) payload.destination_path = destinationPath;
    payload.product_handle = payload.destination_product_handle || payload.source_product_handle;
    payload.set_name = payload.product_expansion;
    if (payload.destination_product_id) {
      payload.items = [{
        item_id: String(payload.destination_product_id),
        item_name: payload.destination_product_title || payload.destination_product_handle || String(payload.destination_product_id),
        quantity: 1,
      }];
    }
    payload.event_source = 'shopify_product';
    payload.send_to = measurementId;
    return payload;
  };

  const publishShopifyDiagnostic = (eventName, payload) => {
    try {
      const result = window.Shopify?.analytics?.publish?.(`tcgking:${eventName}`, payload);
      if (result?.catch) result.catch(() => {});
    } catch (_) {}
  };

  const setStatus = (status, eventName = '') => {
    document.documentElement.dataset.tcgkingProductGa4Status = status;
    if (eventName) document.documentElement.dataset.tcgkingProductGa4LastEvent = eventName;
  };

  const flush = () => {
    if (!analyticsAllowed || !googleQueueReady || typeof window.gtag !== 'function') return;
    while (queue.length) {
      const { eventName, eventData } = queue.shift();
      const payload = normalisePayload(eventData);
      window.gtag('event', eventName, payload);
      publishShopifyDiagnostic(eventName, payload);
      setStatus('dispatched', eventName);
      document.dispatchEvent(new CustomEvent('tcgking:product-event-dispatched', {
        detail: { eventName, payload },
      }));
    }
  };

  const initialiseGoogleQueue = () => {
    if (!analyticsAllowed || googleQueueReady) return;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
    window.gtag('config', measurementId, { send_page_view: false });
    googleQueueReady = true;
    setStatus('ready');
  };

  const updateConsent = () => {
    const privacy = window.Shopify?.customerPrivacy;
    analyticsAllowed = Boolean(privacy?.analyticsProcessingAllowed?.());
    if (analyticsAllowed) {
      initialiseGoogleQueue();
      flush();
    } else {
      setStatus('waiting_for_consent');
    }
  };

  window.tcgkingTrackProductEvent = (eventName, eventData = {}) => {
    if (!allowedEvents.has(eventName)) return;
    queue.push({ eventName, eventData });
    setStatus(analyticsAllowed ? 'queued' : 'waiting_for_consent', eventName);
    if (analyticsAllowed) {
      initialiseGoogleQueue();
      flush();
    }
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;

    if (link.closest('.bb-chase__card')) {
      window.tcgkingTrackProductEvent('product_where_to_pull_click', {
        ...destinationProduct(link),
        click_target: event.target.closest('img') ? 'product_image' : 'product_card',
        placement: link.closest('.bb-chase')?.querySelector('h2')?.textContent.match(/Where to Pull/i)
          ? 'where_to_pull'
          : 'related_sealed_products',
      });
      return;
    }

    if (link.closest('.ym-also-like__card')) {
      window.tcgkingTrackProductEvent('product_recommendation_click', {
        ...destinationProduct(link),
        click_target: event.target.closest('img') ? 'product_image' : 'product_card',
        placement: 'you_might_also_like',
      });
      return;
    }

    const descriptionLink = link.closest('.tcg-product-content__description') && link.pathname.includes('/collections/');
    const recommendationCollectionLink = link.matches('.ym-also-like__collection-link') && link.pathname.includes('/collections/');
    if (!descriptionLink && !recommendationCollectionLink) return;

    window.tcgkingTrackProductEvent('product_collection_click', {
      destination_collection_handle: link.pathname.split('/collections/')[1]?.split(/[?#]/)[0] || '',
      destination_url: link.href,
      link_text: cleanText(link.textContent),
      click_target: 'collection_link',
      placement: descriptionLink ? 'product_description' : 'you_might_also_like',
    });
  }, true);

  document.addEventListener('visitorConsentCollected', updateConsent);
  if (window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) {
        setStatus('consent_api_error');
        return;
      }
      updateConsent();
    });
  } else {
    setStatus('consent_api_unavailable');
  }
})();
